<script lang="ts">
import { defineComponent } from "vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "GevFooter",
  setup() {
    const piniaStore = useFormStore();

    const zeigeStoreData = process.env.VUE_APP_LOG_LEVEL === "trace" || process.env.VUE_APP_LOG_LEVEL === "debug";

    return {
      piniaStore,
      zeigeStoreData,
    };
  },
});
</script>

<template>
  <footer class="c-footer u-mar-t-4">
    <div class="o-container">
      <div class="c-footer__copyright u-pad-t-2">
        <span>
          <a v-if="!piniaStore.state.isMakler" class="c-footer__copyright-link" href="tel:04037663366">
            <span>
              <img src="@/assets/images/Sticky-Telefon-invers.svg" alt="Kontakt Telefon" />
              040 37663-366</span
            >
          </a>
          <a v-else class="c-footer__copyright-link" href="tel:04037663222">
            <span>
              <img src="@/assets/images/Sticky-Telefon-invers.svg" alt="Kontakt Telefon" />
              040 37663-222</span
            >
          </a>
        </span>
        <span class="delimiterOne"
          ><a class="c-footer__copyright-link" href="https://www.gev-versicherung.de/datenschutz/">Datenschutz</a>
          |
          <a class="c-footer__copyright-link" href="https://www.gev-versicherung.de/informationen/impressum/"
            >Impressum</a
          ></span
        >
      </div>
      <div class="c-footer__copyright">
        <span>Grundeigentümer-Versicherung VVaG</span
        ><span class="delimiterOne">Große Bäckerstraße 7 | 20095 Hamburg</span>
      </div>
    </div>
  </footer>

  <pre v-if="zeigeStoreData">
    {{ piniaStore.state }}
  </pre>
</template>

<style scoped>
pre {
  background-color: lightyellow;
  font-size: 0.75rem;
}
</style>
